import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { FormMode } from '../../components/LogonFormComponent/contsants'

interface IFormModeSlice {
  formMode: FormMode
}

const initialState: IFormModeSlice = {
  formMode: FormMode.Default,
}

const formModeSlice = createSlice({
  name: 'formMode',
  initialState,
  reducers: {
    formModeChange(state, action: PayloadAction<FormMode>) {
      state.formMode = action.payload
    },
  },
})

export const { formModeChange } = formModeSlice.actions
export default formModeSlice.reducer
